import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-cards';

// Import required modules
import { EffectFlip, Autoplay } from 'swiper/modules';

// Import additional Swiper styles for flip effect
import 'swiper/css/effect-flip';

// Import phone mockup component
import PhoneMockup from './PhoneMockup';

interface SwiperCardSliderProps {
  images: string[];
}

const SwiperCardSlider: React.FC<SwiperCardSliderProps> = ({ images }) => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-[300px] h-[560px]">
        <Swiper
          effect={'flip'}
          grabCursor={true}
          modules={[EffectFlip, Autoplay]}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          className="w-full h-full"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index} className="rounded-xl overflow-hidden bg-transparent">
              {index === 0 ? (
                <div className="w-full h-full flex items-center justify-center p-0">
                  <img 
                    src={image} 
                    alt="App screenshot" 
                    className="w-full h-full object-contain rounded-lg"
                  />
                </div>
              ) : (
                <PhoneMockup 
                  screenshotSrc={image} 
                  index={index} 
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default SwiperCardSlider;
